export default __webpack_public_path__ + "static/media/818.f9e20fd8.png";